// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__19tCP","title":"FrontImage_title__1oD7k"};